import React from "react";
import NavPublicUser from "../navbarPublicUser"
import Footer from "../Footer";
import PubUserBody from "../pubuserbody";
import PubUserPro from "../PubUsrPro";
import OrderPage from "../OrderPage";
export default function PublicUserPage(){


return(
<div>

    <NavPublicUser />
    <PubUserBody />
    <OrderPage/>
    <PubUserPro />
    <Footer  /> 
</div>

)


}